import React from 'react';
import { RefreshCcw } from 'lucide-react';
import { themes } from './themes';

const ThemePalette = ({ theme, setTheme, compact = false, className = '' }) => {
    return (
        <div className={`bg-white border-4 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] ${compact ? 'p-3' : 'p-6'} ${className}`}>
            {!compact && (
                <h3 className="text-xl font-black uppercase mb-4 flex items-center gap-2">
                    <RefreshCcw size={24} strokeWidth={3} /> Palette
                </h3>
            )}
            <div className={`${compact ? 'flex gap-1 w-full' : 'grid grid-cols-5 gap-2'}`}>
                {Object.keys(themes).map((t) => (
                    <button
                        key={t}
                        onClick={() => setTheme(t)}
                        className={`${compact ? 'flex-1 min-w-0' : 'w-full'} aspect-square border-2 border-black transition-transform hover:scale-110 ${themes[t].bg} ${theme === t ? 'ring-2 ring-black ring-offset-2' : ''}`}
                        aria-label={`Select ${t} theme`}
                    />
                ))}
            </div>
        </div>
    );
};

export default ThemePalette;
